module.exports = __webpack_public_path__ + "static/feature-01-0f7e5b6db10d8a1759bc9fbc64194bd9.png";